<template>
  <div style="margin-top: 0px; margin-left: 50px; margin-bottom: 35px;">
    <table class="tableBorder" style="margin-top: 10px; margin-left: 15px;">
      <tr>
        <th class="spanTableHeader" colspan="3">Site CSS</th>
      </tr>
      <tr>
        <th class="tableHeader">CSS Class</th>
        <th class="tableHeader" style="width: 200px">Appearance</th>
        <th class="tableHeader">Description</th>
      </tr>

      <tr>
        <td class="tableCells textAll">btn-primary</td>
        <td class="tableCells"><button type="button" class="btn btn-primary">Click for Action</button></td>
        <td class="tableCells">buttons</td>
      </tr>

      <tr>
        <td class="tableCells textAll">btn-success</td>
        <td class="tableCells"><button type="button" class="btn  btn-success">Click for Action</button></td>
        <td class="tableCells">buttons</td>
      </tr>

      <tr>
        <td class="tableCells textAll">btn-danger</td>
        <td class="tableCells"><button type="button" class="btn  btn-danger">Click for Action</button></td>
        <td class="tableCells">buttons</td>
      </tr>

      <tr>
        <td class="tableCells seperatorCell" style="border-right-style: hidden;"></td>
        <td class="tableCells seperatorCell" style="border-right-style: hidden;"></td>
        <td class="tableCells seperatorCell"></td>
      </tr>
      <tr>
        <td class="tableCells textAll">bg-primary</td>
        <td class="tableCells">
          <div class="colorDiv bg-primary">This is Example text.</div>
        </td>
        <td class="tableCells">site and accent colors</td>
      </tr>

      <tr>
        <td class="tableCells textAll">bg-success</td>
        <td class="tableCells">
          <div class="colorDiv bg-success">This is Example text .</div>
        </td>
        <td class="tableCells">site and accent colors</td>
      </tr>

      <tr>
        <td class="tableCells textAll">bg-danger</td>
        <td class="tableCells">
          <div class="colorDiv bg-danger">This is Example text.</div>
        </td>
        <td class="tableCells">site and accent colors</td>
      </tr>

      <tr>
        <td class="tableCells textAll">bg-info</td>
        <td class="tableCells">
          <div class="colorDiv bg-info">This is Example text.</div>
        </td>
        <td class="tableCells">site and accent colors</td>
      </tr>

      <tr>
        <td class="tableCells seperatorCell" style="border-right-style: hidden;"></td>
        <td class="tableCells seperatorCell" style="border-right-style: hidden;"></td>
        <td class="tableCells seperatorCell"></td>
      </tr>

      <tr>
        <td class="tableCells textAll">text-primary</td>
        <td class="tableCells"><span class="text-primary" style="font-weight: bold;">Example Text</span></td>
        <td class="tableCells">site and accent colors - TEXT</td>
      </tr>
      <tr>
        <td class="tableCells textAll">text-success</td>
        <td class="tableCells"><span class="text-success" style="font-weight: bold;">Example Text</span></td>
        <td class="tableCells">site and accent colors - TEXT</td>
      </tr>
      <tr>
        <td class="tableCells textAll">text-danger</td>
        <td class="tableCells"><span class="text-danger" style="font-weight: bold;">Example Text</span></td>
        <td class="tableCells">site and accent colors - TEXT</td>
      </tr>

      <tr>
        <td class="tableCells seperatorCell" style="border-right-style: hidden;"></td>
        <td class="tableCells seperatorCell" style="border-right-style: hidden;"></td>
        <td class="tableCells seperatorCell"></td>
      </tr>
      <tr>
        <td class="tableCells textAll">liteblueaccent</td>
        <td class="tableCells">
          <div class="colorDiv liteblueaccent"></div>
        </td>
        <td class="tableCells">other accent colors - BACKGROUND</td>
      </tr>
      <tr>
        <td class="tableCells textAll">medblueaccent</td>
        <td class="tableCells">
          <div class="colorDiv medblueaccent"></div>
        </td>
        <td class="tableCells">other accent colors - BACKGROUND</td>
      </tr>
      <tr>
        <td class="tableCells textAll">yellowaccent</td>
        <td class="tableCells">
          <div class="colorDiv yellowaccent"></div>
        </td>
        <td class="tableCells">other accent colors - BACKGROUND</td>
      </tr>

      <tr>
        <td colspan="3" class="tableCells seperatorCell"></td>
      </tr>
      <tr>
        <td class="tableCells textAll">Settings icon</td>
        <td class="tableCells">
          <div title="Settings" class="material-icons-outlined forSettingsIcon">settings</div>
        </td>
        <td class="tableCells">
          div title="Settings" class="material-icons-outlined forSettingsIcon">settings</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Edit icon</td>
        <td class="tableCells">
          <div title="Edit" class="material-icons-outlined forEditIcon">edit</div>
        </td>
        <td class="tableCells">
          div title="Edit" class="material-icons-outlined forEditIcon">edit</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Delete icon</td>
        <td class="tableCells">
          <div title="Delete" class="material-symbols-outlined forDeleteIcon">delete</div>
        </td>
        <td class="tableCells">
          div title="Delete" class="material-symbols-outlined forDeleteIcon">delete</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Transfer icon</td>
        <td class="tableCells">
          <div title="Transfer Record" class="material-symbols-outlined forTransferIcon">exit_to_app</div>
        </td>
        <td class="tableCells">
          div title="Transfer Record" class="material-icons-outlined forTransferIcon">exit_to_app</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Create Record icon</td>
        <td class="tableCells">
          <div title="Create Record" class="material-icons-outlined forCreateRecordIcon">add_card</div>
        </td>
        <td class="tableCells">
          div title="Create Record" class="material-icons-outlined forCreateRecordIcon">add_card</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Upload Document icon</td>
        <td class="tableCells">
          <div title="Upload" class="material-icons-outlined forUploadIcon">upload_file</div>
        </td>
        <td class="tableCells">
          div title="Settings" class="material-icons-outlined forUploadIcon">upload_file</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Document List icon</td>
        <td class="tableCells">
          <div title="Complete Document List" class="material-icons-outlined forDocumentListIcon">list_alt</div>
        </td>
        <td class="tableCells">
          div title="Complete Document List" class="material-icons-outlined forDocumentListIcon">list_alt</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Log Out icon</td>
        <td class="tableCells">
          <div title="Log Out" class="material-icons-outlined forLogOutIcon" style="background-color: #1063A8;">logout
          </div>
        </td>
        <td class="tableCells">
          div title="Log Out" class="material-icons-outlined forLogOutIcon">logout</td>
      </tr>

      <tr>
        <td class="tableCells textAll">Excel icon</td>
        <td class="tableCells">
          <div><img src="../../../assets/images/exporttoexcel.png" title="Export to Excel"  />
          </div>
        </td>
        <td class="tableCells">
          img src="../../../assets/images/export-to-excel.png" title="Export to Excel" class="forExcelIcon"</td>
      </tr>



    </table>
  </div>
</template>

<script>
// import "../../../node_modules/bootstrap/dist/css/bootstrap.css";
// import "popper.js/dist/popper";
// import "bootstrap";
export default {
  data() { return {}; },
  created() { },
  computed: {},
  methods: {},
};
</script>

<style scoped>
.tableBorder {
  border-collapse: collapse;
  border: 1px solid;
}

.textAll {
  font-weight: bold;
}

.tableCells {
  border: 1px solid;
  padding: 5px;
}

.colorDiv {
  border: 1px solid;
  width: 300px;
  height: 50px;
  vertical-align: middle;
  text-align: center;
  display: table-cell;
}

.seperatorCell {
  background-color: rgb(230, 228, 228);
}

.tableHeader {
  background-color: rgb(236, 245, 236);
  border: 1px solid;
  padding: 5px;
}

.spanTableHeader {
  background-color: rgb(187, 196, 187);
  border: 1px solid;
  padding: 5px;
}
</style>
